import AbstractLayerManager from './AbstractLayerManager';
import Request from '../../Request';

export default class FireLayerManager extends AbstractLayerManager {
	constructor(myKey, instance) {
		super(myKey, instance);
		this.name = "Active Wildfires";
		this.popupName = "Wildfire";
		this.options.hasPanRefresh = false;
		this.options.hasAutoRefresh = true;

		this.dataOptions = {};
	}
	
	refreshLayer() {
		this.requestData();
	}
	
	requestData() {
		this.inst.setLoadingMonitor(this.id, true);

		if(this.tasks.fetchData === undefined) this.tasks.fetchData = new Request({
			url: 'https://api.weatherusa.net/v1/feed/fire',
			data: {'perimeters': 'true'},
			link: 'cancel',
			timeout: 30000,
			onSuccess: this.handleResp.bind(this),
			onError: this.handleError.bind(this)
		});

		this.tasks.fetchData.get();
	}

	handleError(err) {
		console.error(err);
		this.inst.setLoadingMonitor(this.id, false);
	}
	
	handleResp(resp) {
		if(!this.layer) {
			console.error('Could not find layer for layer ID: ' + this.id);
			return false;
		}
		
		let firesGeoJson = resp.body.data;
		if(firesGeoJson === undefined) throw "Fires undefined or API error";

		// Remove all paths from LayerGroup
		this.layer.clearLayers();
		
		L.geoJson(firesGeoJson, {
			onEachFeature: this.handleFeature.bind(this),
			pointToLayer: this.pointToLayer.bind(this),
			style: function (feature) {
				return {
				color: '#f3f300',
				opacity: 0.9,
				weight: 3,
				fillColor: '#d9d900',
				fillOpacity: 0.19,
				};
			}
		}).addTo(this.layer);

		this.inst.setLoadingMonitor(this.id, false);
	}

	handleFeature(feature, layer) {
		layer.on('click', this.handleClick, this);
	}

	pointToLayer(feature, ll) {
		return L.marker(ll, {
			icon: new L.Icon.Default({'imagePath': 'https://www.weatherusa.net/assets/js/images/'}),
			title: feature.properties.name
		});
	}

	handleClick(e) {
		// Show one tab in popup
		e.coalesce = true;

		let data = e.target.feature.properties;

		var popStr = '<div class="fire-event">' +
			'<p>' + data.name + '</p>' +
			'<div class="row no-gutters">' + 
			'<div class="data-box col"><div class="data-label">Acres</div><div class="data-value">' + (data.acres ? data.acres : '') + '</div></div>' +
			'<div class="data-box col"><div class="data-label">% Contained</div><div class="data-value">' + (data.percent_contained ? data.percent_contained : '') + '</div></div>' +
			'</div><div class="row no-gutters">' +
			'<div class="data-box col"><div class="data-label">Fire Cause</div><div class="data-value">' + data.firecause + '</div></div>' +
			'<div class="data-box col"><div class="data-label">Unit ID</div><div class="data-value">' + data.unit_id + '</div></div>' +
			'</div>' +
			'</div>';
		
		this.inst.forwardedClickHandler(this.id, e, popStr);
	}
}
